var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-icon',{staticClass:"mb-1",attrs:{"color":_vm.statusColor(_vm.status),"small":""}},[_vm._v(_vm._s(_vm.statusIcon(_vm.status)))]),_vm._v(" "+_vm._s(_vm.status))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }